import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Header.module.scss";

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const handleBurgerClick = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <header className={styles.header}>
      <nav className={`container ${styles.navbar}`}>
        <Link to="/" className={styles.logo}>
          QuickBus
        </Link>
        <button
          className={styles.burger}
          aria-label="Toggle menu"
          onClick={handleBurgerClick}
        >
          <span className={styles.burgerBar}></span>
          <span className={styles.burgerBar}></span>
          <span className={styles.burgerBar}></span>
        </button>
        <ul
          className={`${styles.navLinks} ${menuOpen ? styles.open : ''}`}
        >
          <li>
            {location.pathname === "/" ? (
              <span className={styles.disabledLink}>Home</span>
            ) : (
              <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            )}
          </li>
          <li>
            {location.pathname === "/my-tickets" ? (
              <span className={styles.disabledLink}>My Tickets</span>
            ) : (
              <Link to="/my-tickets" onClick={() => setMenuOpen(false)}>My Tickets</Link>
            )}
          </li>
          <li>
            {location.pathname === "/privacy-policy" ? (
              <span className={styles.disabledLink}>Privacy Policy</span>
            ) : (
              <Link to="/privacy-policy" onClick={() => setMenuOpen(false)}>Privacy Policy</Link>
            )}
          </li>
          <li>
            {location.pathname === "/refund" ? (
              <span className={styles.disabledLink}>Refund and Cancellation Policy</span>
            ) : (
              <Link to="/refund" onClick={() => setMenuOpen(false)}>Refund and Cancellation Policy</Link>
            )}
          </li>
          <li>
            {location.pathname === "/terms" ? (
              <span className={styles.disabledLink}>Terms and Conditions</span>
            ) : (
              <Link to="/terms" onClick={() => setMenuOpen(false)}>Terms and Conditions</Link>
            )}
          </li>
          <li>
            {location.pathname === "/contactus" ? (
              <span className={styles.disabledLink}>Contact Us</span>
            ) : (
              <Link to="/contactus" onClick={() => setMenuOpen(false)}>Contact Us</Link>
            )}
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
